import { language } from "../../utils/language";
import { IconDownload, IconCheck } from "./Icons";

/**
 * A faithful miniature of the real Pendora download page
 * (OrderMetaCard + ProductCard), driven by the same language strings and the
 * same colour settings a merchant edits in the app. Used by the Delivery Stage
 * and the brand demo. Synthetic order data; labelled as a demo in the UI.
 */
export default function DownloadPageMock({
  lang = "en",
  palette,
  downloads = 0,
  downloadState = "idle", // idle | busy | done
  compact = false,
  dir,
}) {
  const t = language[lang] || language.en;
  const files = [
    { badge: "PDF", bg: "#fee2e2", fg: "#b91c1c", name: "field-notes-vol-1.pdf", size: "12.4 MB" },
    { badge: "EPUB", bg: "#e5e7eb", fg: "#4b5563", name: "field-notes-vol-1.epub", size: "3.1 MB" },
  ];
  const rows = compact ? files.slice(0, 1) : files;

  return (
    <div
      className={`dpm${compact ? " dpm--compact" : ""}`}
      dir={dir}
      style={{
        "--dpm-banner": palette.bannerBg,
        "--dpm-banner-text": palette.bannerText,
        "--dpm-border": palette.border,
        "--dpm-btn": palette.button,
        "--dpm-btn-text": palette.buttonText,
      }}
    >
      <div className="dpm__top">
        <span className="dpm__cta dpm__cta--ghost">{t.visitStore}</span>
        <span className="dpm__cta dpm__cta--solid">{t.orders}</span>
      </div>
      <div className="dpm__frame">
        <div className="dpm__banner">
          <div className="dpm__meta">
            <div>
              <span>{t.orderNumber}</span>
              <strong>#1042</strong>
            </div>
            <div>
              <span>{t.email}</span>
              <strong>maya@example.com</strong>
            </div>
            <div>
              <span>{t.orderPlaced}</span>
              <strong>14 Oct 2026</strong>
            </div>
            <div>
              <span>{t.downloads}</span>
              <strong className="dpm__count" key={downloads}>
                {downloads}
              </strong>
            </div>
            <div className="dpm__total">
              <span>{t.total}</span>
              <strong>$18</strong>
            </div>
          </div>
          <p className="dpm__reception">{t.receptionMessage}</p>
        </div>
        <div className="dpm__card">
          <div className="dpm__product">
            <span className="dpm__thumb" aria-hidden="true">
              <i />
            </span>
            <div className="dpm__ptext">
              <strong>Field Notes, Vol. 1</strong>
              <div className="dpm__pmeta">
                <div>
                  <span>{t.variantName}</span>
                  <em>PDF + EPUB</em>
                </div>
                <div>
                  <span>{t.licenseKey}</span>
                  <em>FN1-7K2Q-9ZT4</em>
                </div>
              </div>
            </div>
            <strong className="dpm__price">$18</strong>
          </div>
          <div className="dpm__files">
            {rows.map((f, i) => (
              <div className="dpm__file" key={f.name}>
                <span className="dpm__badge" style={{ background: f.bg, color: f.fg }}>
                  {f.badge}
                </span>
                <div className="dpm__finfo">
                  <strong>{f.name}</strong>
                  <span>{f.size}</span>
                </div>
                <span
                  className={`dpm__dl${i === 0 && downloadState !== "idle" ? ` is-${downloadState}` : ""}`}
                >
                  {i === 0 && downloadState === "done" ? (
                    <IconCheck size={13} />
                  ) : (
                    <IconDownload size={13} />
                  )}
                  <span>{t.downloadBtnText}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
